var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-import-welcome"},[_c('CustomerImportWelcomeTemplate',{attrs:{"loading":_vm.loading,"numberOfCustomers":_vm.customerImportData.total,"hideSkip":true},on:{"submit":_vm.handleGetStarted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }